module.exports = __webpack_public_path__ + "media/img/logos/2024/horizontal/weihnachten-f6f51f2ead5420e477db95d4d8336c55.svg";